import React from "react";
import { HouseholdType } from "../types/leadWizard";
import { useTranslation } from "../i18n/I18nProvider";
import { OPTIONS } from "../consts";

interface HouseholdTypeStepProps {
  value: HouseholdType | null;
  onSelect: (type: HouseholdType) => void;
  onBack?: () => void;
}

const HOUSEHOLD_SUBLABELS: Record<string, { es: string; en: string }> = {
  SINGLE: { es: "Solo yo necesito cobertura", en: "Coverage for myself only" },
  COUPLE: { es: "Dos adultos en el hogar", en: "Two adults in the household" },
  FAMILY: { es: "Adultos + dependientes", en: "Adults + dependents" },
};

export const HouseholdTypeStep: React.FC<HouseholdTypeStepProps> = ({
  value,
  onSelect,
  onBack,
}) => {
  const { t, language } = useTranslation();

  return (
    <div className="card household-type-card">
      {onBack && (
        <div className="card-header">
          <button
            type="button"
            className="button button-secondary"
            onClick={onBack}
          >
            {t("buttons.back")}
          </button>
        </div>
      )}
      <div className="card-body">
        <h3 className="card-title">{t("wizard.householdType.title")}</h3>
        <p className="section-helper">{t("wizard.householdType.helper")}</p>



        <div className="household-type-grid">
          {OPTIONS.map(({ type, icon }) => {
            const isActive = value === type;
            const sublabel = HOUSEHOLD_SUBLABELS[type];
            return (
              <button
                key={type}
                type="button"
                className={`household-type-option${isActive ? " active" : ""}`}
                onClick={() => onSelect(type)}
              >
                <span aria-hidden="true" className="household-type-icon">
                  {icon}
                </span>
                <span className="household-type-label">
                  {t(`wizard.householdType.options.${type.toLowerCase()}`)}
                </span>
                {sublabel && (
                  <span className="household-type-sublabel">
                    {language === "en" ? sublabel.en : sublabel.es}
                  </span>
                )}
              </button>
            );
          })}
        </div>

      </div>
    </div>
  );
};
